<div class="disable-full-screen" [style.opacity]="modal.is_active ? 100 : 0" [style.visibility]="modal.is_active ? 'visible' : 'hidden'">
  <div class="background" (click)="close()"></div>
  <div class="container-center">
    <div class="modal">
      <div class="modal-header">
        <div class="modal-header-txt">{{isEditMode ? "Edit" : "Add"}} Schedule</div>
        <div style="position:relative">
          <div class="title-close"><i class="material-icons" (click)="close()">close</i></div>
        </div>
      </div>
      <div class="items-area">
        <div class="item">
          <div class="item-title"><span>Choose arming condition</span></div>
          <select [(ngModel)]="selArmingCondition">
            <option *ngFor="let armingCondition of armingConditions" [ngValue]="armingCondition">{{armingCondition.name}}</option>
          </select>
        </div>
        <div class="item">
          <div class="item-title"><span>Select time</span></div>
          <div class="flex align-center">
            <select class="arm-time" [(ngModel)]="selHour">
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select><span class="ml-10 mr-10">:</span>
            <select class="arm-time" [(ngModel)]="selMinutes">
              <option *ngFor="let minute of minutes" [value]="minute">{{minute}}</option>
            </select>
          </div>
        </div>
        <div class="item">
          <div class="item-title"><span>Select day</span></div>
          <div class="days" [class.disable-select]="isDisable">
            <div class="day-of-week" (click)="!isDisable && setDayOfWeek(1)" [class.selected]="selDaysOfWeek.indexOf(1)!==-1">S</div>
            <div class="day-of-week" (click)="!isDisable && setDayOfWeek(2)" [class.selected]="selDaysOfWeek.indexOf(2)!==-1">M</div>
            <div class="day-of-week" (click)="!isDisable && setDayOfWeek(3)" [class.selected]="selDaysOfWeek.indexOf(3)!==-1">T</div>
            <div class="day-of-week" (click)="!isDisable && setDayOfWeek(4)" [class.selected]="selDaysOfWeek.indexOf(4)!==-1">W</div>
            <div class="day-of-week" (click)="!isDisable && setDayOfWeek(5)" [class.selected]="selDaysOfWeek.indexOf(5)!==-1">T</div>
            <div class="day-of-week" (click)="!isDisable && setDayOfWeek(6)" [class.selected]="selDaysOfWeek.indexOf(6)!==-1">F</div>
            <div class="day-of-week" (click)="!isDisable && setDayOfWeek(7)" [class.selected]="selDaysOfWeek.indexOf(7)!==-1">S</div>
          </div>
        </div>
      </div>
      <div class="tail-btn-area">
        <div class="button button-primary" (click)="doAction()" [class.disabled]="selDaysOfWeek.length === 0 || isLoading">
          <div class="btn-inner"><span>{{isEditMode ? "Edit" : "Add"}}</span></div>
        </div>
        <div class="button button-white" (click)="close()" style="margin:0" [class.disabled]="isLoading">
          <div class="btn-inner">Cancel</div>
        </div>
      </div>
      <div class="loader absolute" *ngIf="isLoading">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
        </svg>
      </div>
    </div>
  </div>
</div>
<dealer-warning [modal]="m_warning"></dealer-warning>